<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-18 11:54:16
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-27 15:04:57
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/transportbg1.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <!-- <div style="height:55px;"></div> -->
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div style="height:55px;"></div>
              <div :class="$i18n.locale=='zh'?'text zh-font':'text en-font'">{{$t('transportationVisualization.content')}}</div>
              <div style="height:20px;"></div>
              <span class="jiantou"  @click="show">{{ $t('index.about.more') }}<i :class="showHidden?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span>
              <div class="main ani animate__animated animate__fadeInDown" v-if="showHidden">
                  <img v-if="$i18n.locale=='zh'" style="width:100%" src="@/assets/images/transportVisua.png">
                  <img v-if="$i18n.locale=='en'" style="width:100%" src="@/assets/images/transportVisua-en.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return{
      showHidden:false
    }
  },
  methods:{
    show() {
      this.showHidden = !this.showHidden
    }
  }
})
</script>
<style scoped>
  .topPoint::after {
    width: 25px;
    height: 25px;
    content: "";
    position: absolute;
    background: #ed6d00;
    border-radius: 50%;
    z-index: 1;
    top: -12.5px;
    right: -12.5px;
  }
  .inner-pannel{
    min-height: 100%;
    padding-bottom: 54px;
    position: static;
    /* position: relative; */
    /* position: absolute; */
    width: 100%;
    font-family: "Lato";
  }
  .content-page img{
    margin-top: 20px;
  }
  .main{
    width: 577px;
  }
  .jiantou{
    color: #ffffff!important;
    font-family: 'Lato','Microsoft JhengHei';
    /* position: absolute; */
    /* right: 0; */
    cursor:pointer;
  }
  .el-icon-arrow-down::before {
    color: #ffffff!important;
  }
  .el-icon-arrow-up::before{
    color: #ffffff!important;
  }
  /deep/ .el-collapse-item__wrap{
    padding-left: 0;
  }
  /deep/ .el-collapse {
    border-bottom: 0;
  }
  /deep/ .el-collapse-item__wrap{
    border-bottom: 0;
  }
  /deep/ .el-collapse-item__header{
    border-bottom: 0px!important;
  }
  @media screen and (max-width:768px) {
    /deep/ .el-collapse {
      width: 100%!important;
    }
    .main{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/transportationVisualization/transportationVisualization.vue